module.exports = __webpack_public_path__ + "img/Mockup.6db4b15a.jpg";